import {useDropzone} from "react-dropzone";
import styled from "styled-components";
import theme from "../../style/theme";
import useDidMountEffect from "../../utils/custom-hook/use-did-mount-effect";
import {OutlinedBlackButton} from "../button/OutlinedBlackButton";
import ImageAddLineIcon from "../icons/ImageAddLineIcon/ImageAddLineIcon";

interface Props {
    setFiles: (files: File[]) => void;
}

export const LocationImageDropZone: React.FC<Props> = (
    {
        setFiles
    }
) => {
    const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone();

    useDidMountEffect(() => {
        setFiles(acceptedFiles);
    }, [acceptedFiles]);

    return (
        <div {...getRootProps({className: "dropzone"})}>
            <EmptyImageContainer>
                <input {...getInputProps()} />
                <ImageAddLineIcon
                    width="4.313rem"
                    height="4.313rem"
                    fill={theme.palette.primitives.gray300}
                />
                <AddImageButtonContainer>
                    <OutlinedBlackButton
                        width="10.625rem"
                        height="3.188rem"
                        text="파일 불러오기"
                        onClick={open}
                    />
                </AddImageButtonContainer>
                <EmptyImageText>또는 파일을 드래그해서 놓으세요</EmptyImageText>
            </EmptyImageContainer>
        </div>
    );
};

const EmptyImageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 23rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.palette.primitives.gray200};
  border-radius: 0.25rem;
  margin-top: 2rem;
`;

const EmptyImageText = styled.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.gray500};
`;

const AddImageButtonContainer = styled.div`
  margin: 1.75rem 0 1rem 0;
`;
